export default __webpack_public_path__ + "img/7bd3e214c60d3a369988a1f67d0bcfb2.svg";